import React from 'react';
import {
  CloseButton,
  PrimaryButton,
  SecondaryButton,
  TertiaryButton,
  DangerButton,
  TextButton,
  TextWarningButton,
} from "@components/library/button/index";

const buttonInputs = [
  { className: 'bf-button', size: 'small', disabled: false, content: 'Sm Button' },
  { className: 'bf-button', size: 'medium', disabled: false },
  { className: 'bf-button', size: 'large', disabled: false, content: 'Large Button' },
  { className: 'bf-button', disabled: true, content: 'Disabled' },
];

const buttonInputs2 = [
  { className: 'bf-button', key: 0 },
  { className: 'bf-button', disabled: true, key: 1 },
];

export const Buttons = () => (
  <div className="example-container">
    <div className="buttons-container primary">
      {buttonInputs.map((inputs) => (
        <PrimaryButton {...inputs} key={`primary-${inputs.size}`}>
          {inputs.content || 'Primary Button'}
        </PrimaryButton>
      ))}
    </div>
    <div className="buttons-container secondary">
      {buttonInputs.map((inputs) => (
        <SecondaryButton {...inputs} key={`secondary-${inputs.size}`}>
          {inputs.content || 'Secondary Button'}
        </SecondaryButton>
      ))}
    </div>
    <div className="buttons-container tertiary">
      {buttonInputs.map((inputs) => (
        <TertiaryButton {...inputs} key={`tertiary-${inputs.size}`}>
          {inputs.content || 'Tertiary Button'}
        </TertiaryButton>
      ))}
    </div>
    <div className="buttons-container warning">
      {buttonInputs.map((inputs) => (
        <DangerButton {...inputs} key={`danger-${inputs.size}`}>
          {inputs.content || 'Danger Button'}
        </DangerButton>
      ))}
    </div>
    <div className="buttons-container warning-hollow">
      <button className="button warning-hollow sm">Sm Button</button>
      <button className="button warning-hollow">Warning Button</button>
      <button className="button warning-hollow lg">Large Button</button>
      <button className="button warning-hollow sm" disabled>Disabled</button>
    </div>
    <div className="buttons-container text-button">
      {buttonInputs2.map((inputs) => (
        <TextButton {...inputs} key={`text-${inputs.key}`} icon="bff-copy">
          Text Button
        </TextButton>
      ))}
    </div>
    <div className="buttons-container text-warning-button">
      {buttonInputs2.map((inputs) => (
        <TextWarningButton {...inputs} key={`text-warning-${inputs.key}`} icon="bff-trash">
          Text Warning Button
        </TextWarningButton>
      ))}
    </div>
    <div className="buttons-container close">
      {buttonInputs2.map((inputs) => (
        <CloseButton {...inputs} key={`close-${inputs.key}`} />
      ))}
      (close button)
    </div>
  </div>
);
